import React, { Fragment, useEffect, useState } from 'react';
import { IImage } from './interfaces';
import { Box, CustomTheme, useTheme } from '@mui/material';
import { BrokenImage } from '@mui/icons-material';
import { Loader } from '@components/feed/Loader';

export const Image: React.FC<IImage> = ({
  imageSrc,
  aspectRatio,
  height,
  borderRadius,
  sx,
  width = '100%',
}): JSX.Element => {
  const theme = useTheme<CustomTheme>();

  const [imageError, setImageError] = useState<boolean>(false);
  const [imageLoaded, setImageLoaded] = useState<boolean>(false);

  useEffect(() => {
    setImageError(false);
    setImageLoaded(false);
  }, [imageSrc]);

  return (
    <Box
      sx={{
        mt: '3px',
        width,
        position: 'relative',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        overflow: 'hidden',
        backgroundColor: '#f0f0f0',
        ...(borderRadius ? { borderRadius: '4px' } : {}),
        border: `1px solid ${theme.palette.grey[300]}`,
        ...(height ? { height } : {}),
        ...(!height && aspectRatio ? { aspectRatio } : {}),
        ...(!height && !aspectRatio ? { height: '150px' } : {}),
        ...sx,
      }}
    >
      {imageError ? (
        <BrokenImage sx={{ fontSize: 48, color: 'gray' }} />
      ) : (
        <Fragment>
          {!imageLoaded && (
            <Loader
              sx={{
                position: 'absolute',
              }}
              color={theme.palette.grey[400]}
            />
          )}

          <Box
            component="img"
            src={imageSrc}
            onLoad={() => setImageLoaded(true)}
            onError={() => {
              setImageLoaded(true);
              setImageError(true);
            }}
            sx={{
              width: '100%',
              height: '100%',
              objectFit: 'cover',
              opacity: imageLoaded ? 1 : 0,
              transition: 'opacity 200ms ease-in-out',
              ...(borderRadius ? { borderRadius: '4px' } : {}),
            }}
          />
        </Fragment>
      )}
    </Box>
  );
};
